import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaCar, FaTools, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
import Button from '../../components/Button';

const WebTallerPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Atrae clientes mientras reparas",
      description: "Tu web trabaja 24/7, captando clientes potenciales incluso cuando estás ocupado en el taller. Presenta tus servicios y presupuestos siempre."
    },
    {
      title: "Diferénciate de otros talleres",
      description: "El 74% de los talleres mecánicos aún no tienen presencia online profesional. Destaca con una web moderna que transmita profesionalidad y confianza."
    },
    {
      title: "Muestra tus especialidades",
      description: "Destaca tu experiencia en marcas específicas, tipos de reparaciones o servicios exclusivos. Atrae al cliente que necesita exactamente lo que ofreces."
    },
    {
      title: "Posiciónate localmente en Google",
      description: "Aparece cuando buscan 'taller mecánico en [tu zona]'. El 86% de las búsquedas de servicios de automóvil incluyen términos de proximidad."
    },
    {
      title: "Facilita la reserva de citas",
      description: "Reduce llamadas y optimiza tu agenda con un sistema claro para solicitar citas de mantenimiento o reparación. Organiza mejor tu trabajo diario."
    },
    {
      title: "Recupera la inversión con rapidez",
      description: "Con solo 2-3 clientes nuevos que lleguen por la web, recuperas la inversión en el primer trimestre. Después todo son beneficios."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaCar />,
      title: "Catálogo visual de servicios",
      description: "Presentación profesional de todos tus servicios: mecánica, electrónica, neumáticos, chapa y pintura. Descripciones claras con precios orientativos."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a móviles",
      description: "El 68% de las búsquedas de talleres se hacen desde el móvil, muchas veces en situaciones de emergencia. Tu web será perfecta en cualquier dispositivo."
    },
    {
      icon: <FaTools />,
      title: "Sección de especialidades",
      description: "Destaca tus servicios diferenciadores, especialización en marcas concretas o reparaciones específicas. Fundamental para captar al cliente adecuado."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización SEO local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Aparece cuando busquen talleres cercanos con toda tu información actualizada."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de solicitud de citas",
      description: "Formulario específico para solicitar cita, indicando tipo de vehículo, servicio requerido y preferencia horaria. Optimiza tu agenda y reduce llamadas."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para talleres",
      description: "Posicionamiento para términos como 'taller mecánico en [tu zona]' o tus especialidades. Optimización de contenidos para atraer a tu cliente ideal."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para talleres mecánicos que necesitan una web sencilla pero profesional para comenzar su presencia online.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por talleres. Equilibrio perfecto entre precio y funcionalidades para captar más clientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para talleres que quieren destacar con más funcionalidades y mejor posicionamiento en el sector de la automoción.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu taller, servicios y especialidades. Planificamos una web que transmita profesionalidad y genere confianza en tus servicios.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño técnico y profesional. Implementamos todas las secciones necesarias para mostrar tus servicios y especialidades.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO local para que te encuentren los clientes de tu zona.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para talleres",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Presentación profesional de servicios",
      us: true,
      others: false
    },
    {
      label: "Preparada para sistema de citas",
      us: true,
      others: false
    },
    {
      label: "Sección de especialización técnica",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Durante años confiamos solo en el boca a oreja para conseguir clientes. Desde que lanzamos nuestra web, estamos recibiendo clientes que buscan específicamente nuestras especialidades en inyección electrónica y diagnóstico avanzado. La web nos permite explicar estos servicios complejos y mostrar nuestras habilidades, lo que atrae a clientes que valoran la calidad sobre el precio. El formulario de solicitud de citas ha reducido significativamente las interrupciones telefónicas, permitiéndonos organizar mejor el trabajo diario. La inversión se amortizó en tiempo récord.",
    author: "Antonio Rodríguez",
    position: "Propietario",
    company: "Talleres Rodríguez",
    avatar: "/servicios/testimonios/taller.webp"
  };
  
  const founderMessage = "En el sector de la automoción, la confianza técnica es el factor decisivo. Desarrollamos webs para talleres que transmiten profesionalidad y experiencia, destacando especialidades técnicas con un lenguaje accesible para el cliente final. Un taller con presencia digital adecuada no solo atrae más clientes, sino que capta un perfil que valora la calidad sobre el precio.";
  
  // FAQs específicas para web de talleres
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi taller mecánico?",
      answer: "Una web profesional es fundamental para talleres mecánicos por diversos motivos estratégicos: 1) El 76% de los conductores buscan talleres en internet antes de decidir dónde llevar su vehículo; 2) Permite presentar tus especialidades técnicas y diferenciarte de la competencia genérica; 3) Te posiciona en Google Maps y búsquedas locales como 'taller cerca de mí', fundamentales para captar clientes de proximidad; 4) Proporciona disponibilidad 24/7 de información sobre servicios, precios orientativos y horarios; 5) Facilita la gestión de citas, reduciendo interrupciones telefónicas y mejorando la organización diaria; 6) Permite mostrar trabajos realizados y testimonios, generando confianza en un sector donde la reputación es crucial; 7) Transmite profesionalidad y modernidad, atrayendo a un perfil de cliente que valora calidad sobre precio. Según estudios del sector, los talleres con presencia web profesional incrementan entre un 20-30% su captación de nuevos clientes en el primer año, especialmente en perfiles de mayor valor añadido.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se presentarán mis servicios en la web?",
      answer: "Tus servicios se presentarán de forma profesional y técnica para inspirar confianza: 1) Organización por categorías claras (mecánica general, electrónica, neumáticos, chapa y pintura, etc.) para facilitar la navegación; 2) Descripción detallada de cada servicio, explicando el proceso, ventajas y beneficios para el cliente; 3) Imágenes profesionales que muestren instalaciones, herramientas especializadas y resultados; 4) Sección destacada para especialidades técnicas o marcas específicas con las que trabajas; 5) Precios orientativos o rangos de precios para servicios estándar (cambios de aceite, frenos, etc.); 6) Galería de trabajos realizados para mostrar tu experiencia; 7) Explicación de la calidad de recambios utilizados y posibles garantías ofrecidas. También incluiremos llamadas a la acción claras para solicitar presupuestos o citas. Te proporcionaremos acceso a un panel intuitivo donde podrás actualizar información sobre servicios, precios o añadir nuevos trabajos realizados a la galería.",
      category: "Contenidos"
    },
    {
      question: "¿Incluís un sistema de citas online?",
      answer: "Los sistemas de citas online no están incluidos en los precios base y se presupuestan por separado según tu modelo de trabajo: 1) Sistema básico de solicitud de citas (desde 100€) - Formulario avanzado donde el cliente especifica vehículo, servicio requerido y preferencia horaria, recibiendo tú una notificación para confirmar; 2) Sistema intermedio con calendario (desde 200€) - Integración con Google Calendar o similar, donde el cliente ve disponibilidad real y reserva en huecos específicos; 3) Sistema avanzado especializado (desde 350€) - Plataforma completa con gestión de mecánicos, tiempos por servicio, recordatorios automáticos y seguimiento de reparaciones. Estos sistemas son complementos opcionales a la web que requieren configuración específica según tu forma de trabajo. También podemos integrar plataformas como Booksy o tu sistema actual si ya utilizas alguno. El presupuesto exacto se determina tras analizar tus necesidades específicas, tipo de servicios y volumen de reparaciones.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas para mantener la relación calidad-precio: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, servicios, sobre nosotros, galería y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, añadiendo secciones como especialidades técnicas, marcas con las que trabajas, equipamiento, procesos de trabajo o páginas específicas para servicios principales; 3) El plan Premium (400€) permite entre 10-15 páginas, pudiendo incluir páginas detalladas para cada tipo de servicio, blog de consejos de mantenimiento, página de ofertas, sección de preguntas frecuentes, etc. Si necesitas más páginas de las incluidas en tu plan, tienen un coste adicional de 40€ por página. Para webs realmente extensas con más de 15 páginas, recomendamos solicitar un presupuesto personalizado. La mayoría de talleres obtienen excelentes resultados con el número de páginas incluido en los planes estándar, ya que lo importante es la calidad del contenido y su enfoque a generar confianza.",
      category: "Planes"
    },
    {
      question: "¿Qué fotos utilizaréis en mi web?",
      answer: "Las imágenes son cruciales para transmitir profesionalidad y confianza en un sector técnico como el de talleres. Tienes estas opciones: 1) Fotografías propias: Si dispones de imágenes profesionales de tu taller, equipamiento y trabajos realizados, las optimizaremos y utilizaremos como contenido principal; 2) Sesión fotográfica profesional: Podemos recomendarte fotógrafos especializados en sectores industriales (presupuesto aproximado: 200-300€ por sesión completa); 3) Imágenes mixtas: Combinación de tus mejores fotos actuales con algunas imágenes de stock seleccionadas; 4) Consejos fotográficos: Te proporcionamos una guía para que puedas tomar mejores fotos de tus instalaciones y trabajos realizados. Para talleres mecánicos, recomendamos especialmente mostrar: instalaciones limpias y ordenadas, equipamiento técnico especializado, trabajos en proceso (antes/después), y el equipo humano, ya que estos elementos generan confianza en un sector donde los clientes suelen tener incertidumbre sobre la calidad del servicio.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye servicios esenciales para el funcionamiento óptimo de tu web: 1) Alojamiento en servidores de alta velocidad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionamos acceso a un panel intuitivo donde podrás actualizar servicios, precios, añadir trabajos a la galería, o modificar información básica como horarios o promociones temporales. Para talleres, es especialmente útil poder actualizar rápidamente ofertas temporales (ej. revisiones pre-ITV) o servicios estacionales. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, asegurar la renovación del dominio y el alojamiento seguro de los contenidos. Si añades un sistema de citas online, este podría tener un coste de mantenimiento adicional según su complejidad.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para talleres
      pageTitle="Web para Talleres Mecánicos desde 200€ | Presencia Online Profesional"
      pageDescription="Diseño web especializado para talleres mecánicos. Muestra tus servicios, especialidades técnicas y posicionamiento local para atraer más clientes en tu zona."
      pageKeywords="página web barata taller mecánico, web para talleres, diseño web taller, página web automóvil barata, web taller económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-taller"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para talleres mecánicos y automoción desde 200€"
      heroSubtitle="Diseñamos webs profesionales para talleres que atraen clientes y muestran tus servicios. Sin conocimientos técnicos, mantenimiento sencillo, lista en 7 días."
      heroImage="/servicios/tipo-cliente/hero-taller.webp"
      badges={['Desde 200€ (pago único)', 'Mantenimiento 20€/mes', 'Optimizada para SEO local', 'Soporte incluido']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de taller mecánico"
      pricingSubtitle="Elige el plan que mejor se adapte a las necesidades de tu taller. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para talleres?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Jaime Vela"
            founderTitle="Co-fundador y Director de Marketing"
            avatarSrc="/sobre nosotros/foto-jaime.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de taller?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu taller"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para talleres"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu taller con presencia online profesional"
      ctaDescription="Una inversión inteligente que atraerá nuevos clientes, mostrará tus especialidades técnicas y diferenciará tu taller de la competencia. Recupera la inversión en pocas semanas."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebTallerPage; 

